var _excluded = ["onClickNotificationSetting", "address", "notifications"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Checkbox } from '@domain-group/fe-co-form-elements';
import { notificationSettings } from '../../types';
import { Modal } from '../../components';
import * as styles from './update-notification-settings.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var UpdateNotificationSettings = _ref => {
  var onClickNotificationSetting = _ref.onClickNotificationSetting,
    address = _ref.address,
    _ref$notifications = _ref.notifications,
    notifications = _ref$notifications === void 0 ? {} : _ref$notifications,
    modalProps = _objectWithoutProperties(_ref, _excluded);
  var handleCheckboxChange = _ref2 => {
    var _ref2$target = _ref2.target,
      checked = _ref2$target.checked,
      value = _ref2$target.value;
    return onClickNotificationSetting(value, checked);
  };
  return ___EmotionJSX(Modal, _extends({}, modalProps, {
    title: "Notification settings",
    buttonText: "Update notification settings"
  }), ___EmotionJSX("p", null, "Update notification settings for", ' ', ___EmotionJSX("strong", {
    css: styles.address
  }, address === null || address === void 0 ? void 0 : address.line1, ", ", address === null || address === void 0 ? void 0 : address.division.name, ", ", address === null || address === void 0 ? void 0 : address.state.abbrev, ' ', address === null || address === void 0 ? void 0 : address.postcode)), ___EmotionJSX("ul", null, notificationSettings.map(setting => {
    var _notifications$settin;
    return ___EmotionJSX("li", {
      key: setting.key
    }, ___EmotionJSX(Checkbox, {
      css: styles.checkbox,
      value: setting.key,
      checked: (_notifications$settin = notifications[setting.key]) !== null && _notifications$settin !== void 0 ? _notifications$settin : false,
      labelContent: ___EmotionJSX("div", {
        css: styles.label
      }, ___EmotionJSX("p", {
        css: styles.labelHeading
      }, setting.label), ___EmotionJSX("p", {
        css: styles.description
      }, setting.description)),
      onChange: handleCheckboxChange
    }));
  })));
};
export default UpdateNotificationSettings;